const deleteButton = (editor) => {
    editor.BlockManager.add(`deleteButton`, {
        label: `Delete Button`,
        category: 'Buttons',
        content: '<div class="btn pointer bi bi-trash delete-btn">&nbsp;Delete</div>',
        attributes: { class: 'fa fa-plus-square' }
    });
}

export default deleteButton;